export default __webpack_public_path__ + "static/media/urlNotfound.e05c6ba9.png";